import React from "react"
import { withDynamicComponents } from "higher-order-components"
import { GlobalNavOverlay } from "components"
import GlobalNavItemGridBlock from "../global-nav-item-grid"

const GlobalNavOverlayBlock = props => <GlobalNavOverlay {...props} />

export default withDynamicComponents({
  componentWhitelist: [GlobalNavItemGridBlock]
})(GlobalNavOverlayBlock)



// WEBPACK FOOTER //
// ./src/blocks/global-nav-overlay/index.jsx